import { Component, OnInit, ViewChild } from '@angular/core';
import { TrainingDays, Day, SelectedMode } from '../../../api/interfaces/register';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { RegisterService } from 'src/app/api/services/register/register.service';
import { FormValidatorService } from '../../../services/formValidator/form-validator.service';
import { SharedDataService } from '../../../services/sharedData/shared-data.service';
import { TrainingTypeEnum } from '../../../enums/training-type';
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';


@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss']
})
export class StepTwoComponent implements OnInit {

  @ViewChild('matRef') matRef: MatSelect;
  cardClass1="card";
  cardClass2="card";
  trainingDays: TrainingDays[] = [];
  valid: boolean = false;
  isMobile: boolean = false;

  //movido domingo a index 1 por cambios en backend
  days: Day[] = [
    {name:"Lunes", selected: false, index: 2, disabled: false},
    {name:"Martes", selected: false, index: 3, disabled: false},
    {name:"Miércoles", selected: false, index: 4, disabled: false},
    {name:"Jueves", selected: false, index: 5, disabled: false},
    {name:"Viernes", selected: false, index: 6, disabled: false},
    {name:"Sábado", selected: false, index: 7, disabled: false},
    {name:"Domingo", selected: false, index: 1, disabled: false},
  ];

  presencial: boolean = false;
  selected: boolean = false;

  modeForm = new FormGroup({
    mode: new FormControl(),
    trainingDays: new FormControl(),
    days: new FormControl([]),
  });
  
  constructor(
    private registerService: RegisterService,
    private formValidatorService: FormValidatorService,
    private sharedData: SharedDataService,
    private mobileDetectorService: MobileDetectorService,
  ) { }

  ngOnInit(): void {

    this.isMobile = this.mobileDetectorService.isMobile();
    this.modeForm.statusChanges
    .subscribe(val => this.formValidatorService.onFormValidation(val, "step2","mode"));

    this.registerService.getTrainingDays()
    .subscribe(response => {
      this.trainingDays = response;
      // remove the first two elements from response because they are useless here
      this.trainingDays.splice(0,2);
    },
      error => {
        console.error(error);
      });

      this.sharedData.currentMessage.subscribe(message => {
        if(message==="saveStep") {
          sessionStorage.setItem('mode', JSON.stringify(this.modeForm.value));
        }
    });
  }

  enablePresencial() {
    this.presencial = true;
    this.selected = false;
    this.unselectAllDays();
    this.saveMode(0);
  }

  disablePresencial() {
    this.presencial = false;
    this.selected = true;
    this.matRef.options.forEach((data: MatOption) => data.deselect());
    this.unselectAllDays();
    this.saveMode(1);
  }

  unselectAllDays() {
    this.days.forEach(day => {
      day.selected = false;
      day.disabled = false;
    });
    this.modeForm.patchValue({days: []});
  }

  saveDay(day: Day) {
    const position: number = this.days.findIndex(element => element.index == day.index);
    this.days[position].selected = !day.selected;
    let selected: any = [];
    this.days.forEach(day => {
      if(day.selected) {
        selected.push(day);
      }
    });
    this.modeForm.value.days = selected;
    if(this.modeForm.value.mode != TrainingTypeEnum.ONLINE) {
      this.changeValid();
    } else {
      if(!this.days.every(day => day.selected)) {
        this.valid = true;
      }
    }
    this.changeValid();
  }

  saveTrainingDay(option: TrainingDays) {

    this.selected = true;
    this.unselectAllDays();
    this.days.forEach(day => {
      day.selected = false;
    });
    this.modeForm.value.trainingDays = option;
    this.modeForm.value.mode = option.grupoId;
    this.days.map(day => {
      day.disabled = false;
    })
    this.days.map(day => {
      option.entrenamientoGruposDias.forEach(dayWeek => {
        if(day.index == dayWeek.diaSemana) {
          day.disabled = true;
        }
      })
    });
    this.valid = true;
  }

  /**
   * is valid if user selected online and at least one day or is presencial
   */
  changeValid() {
    if( (this.modeForm.value.mode == 2 && this.modeForm.value.days.length > 0) || this.modeForm.value.trainingDays) {
      this.valid = true;
    } else {
      this.valid = false;
    }
  }

  saveMode(mode: number) {
    this.modeForm.value.mode = mode;
    if(mode === TrainingTypeEnum.ONLINE) {
      this.cardClass2 = "cardSelected";
      this.cardClass1 = "card";
      this.modeForm.value.mode = 2; //id 2 corresponde a online
      this.modeForm.value.trainingDays = null;
      this.valid = false;
    } else {
      this.cardClass1 = "cardSelected";
      this.cardClass2 = "card";
      this.changeValid();
    }
  }

}
